const qcToolWebUrl = import.meta.env.VITE_QC_TOOL_WEB_URL ?? '';

export default function SidebarWidget() {
  return (
    <div
      className={`
        mx-auto w-full max-w-60 rounded-2xl bg-gray-50 px-4 py-4 text-center dark:bg-white/[0.03]`}
    >
      <h3 className="mb-2 font-semibold text-gray-900 dark:text-white">
        BhāshāSetu QC Lite
      </h3>

      <a
        href={qcToolWebUrl || '#'}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center p-3 font-medium text-white rounded-lg bg-brand-500 text-theme-sm hover:bg-brand-600"
      >
        Go To QC Tool
      </a>
    </div>
  );
}
